import React from 'react'
import request from 'superagent'
import Cookie from 'react-cookie'
import { object, string } from 'prop-types'
import Tracker from '../../../../../_plugins/lib/tracker'
import PhoneNumber from './phoneNumber.jsx'

class ContactCenterCustomerNumber extends React.Component {
  componentDidMount () {
    if (!this.props.type) return
    const { agentData: { agent } } = this.props
    this.getCustomerNumber(agent)
  }

  getCustomerNumber (agent) {
    const { settings, phoneNumber } = this.props
    if (!agent) return true
    if (settings.customerNumberPhones.indexOf(phoneNumber.replace(/ /g, '')) === -1) {
      return true
    }

    const customerNumber = Cookie.load('customer-number') || false

    if (customerNumber) {
      this.setCustomerNumber(customerNumber)
      return true
    }

    try {
      const params = { agent: agent, session_id: Cookie.load('owts-tmp-v2'), noCache: 1 }

      request
        .get(settings.customerNumberAPIEndpoint)
        .query(params)
        .end(this.customerNumberResponse)
    } catch (e) {
      // return false;
    }
  }

  customerNumberResponse (err, res) {
    if (err || !(res && res.body && res.body.customer_number)) return
    let endDate = new Date()
    endDate.setHours(23, 59, 59, 999)
    Cookie.save('customer-number', res.body.customer_number, { path: '/', expires: endDate })
    this.setCustomerNumber(res.body.customer_number)
  }

  setCustomerNumber (customerNumber) {
    customerNumber = ('000' + customerNumber).slice(-4)
    Tracker.track('customer_number', customerNumber)
    this.setState({ customerNumber: customerNumber })
  }

  getTypeData () {
    const { customerNumber, type, settings, phoneNumber } = this.props
    const data = {
      productType: null,
      trackingName: 'vac-',
      customerNumber: null,
      showCustomerNumber: false,
      liveChat: false,
      name: null
    }
    switch (type.toLowerCase()) {
      case 'parking':
        data.trackingName += 'parking'
        data.customerNumber = customerNumber
        data.showCustomerNumber = (customerNumber && settings.customerNumberPhones.indexOf(phoneNumber.replace(/ /g, '')) !== -1)
        break
      case 'hotels':
        data.trackingName += 'hotels'
        data.customerNumber = customerNumber
        data.showCustomerNumber = (customerNumber && settings.customerNumberPhones.indexOf(phoneNumber.replace(/ /g, '')) !== -1)
        break
      case 'lounges':
        data.trackingName += 'lounges'
        data.customerNumber = customerNumber
        data.showCustomerNumber = (customerNumber && settings.customerNumberPhones.indexOf(phoneNumber.replace(/ /g, '')) !== -1)
        break
      case 'insurance':
        data.trackingName += 'insurance'
        data.productType = 'switchboardInsuranceNumber'
        data.liveChat = 'Insurance'
        data.name = 'Insurance'
        break
      case 'medical':
        data.trackingName += 'medical'
        data.productType = 'switchboardMedicalNumber'
        data.liveChat = 'Insurance'
        data.name = 'Medical cover'
        break
      case 'carhire':
        data.trackingName += 'car-hire'
        data.productType = 'switchboardCarHireNumber'
        data.livechat = 'Car Hire'
        data.name = 'Car hire'
        break
      case 'theatre':
        data.trackingName += 'theatre'
        data.productType = 'switchboardTheatreNumber'
        data.liveChat = 'Short Breaks'
        data.name = 'Theatre'
        break
    }
    return data
  }

  render () {
    if (!this.props.type) return null
    const { agents, settings, agentData } = this.props
    const type = this.getTypeData()
    return (
      <span>
        <PhoneNumber agents={agents} agentData={agentData} settings={settings} customerNumber={type.customerNumber} productType={type.productType} trackingName={type.trackingName + '-phone'} showCustomerNumber={type.showCustomerNumber} />
      </span>
    )
  }
}

ContactCenterCustomerNumber.propTypes = {
  type: string,
  agentData: object,
  settings: object,
  phoneNumber: string
}

export default ContactCenterCustomerNumber



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/contactCenterCustomerNumber.jsx